export default __webpack_public_path__ + "static/media/fox.b4778fe5.png";